import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, Input } from "@angular/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: "jni-loader",
  imports: [CommonModule, LottieComponent, DialogModule],
  templateUrl: "./loader.component.html",
  standalone: true,
  styleUrl: "./loader.component.scss",
})
export class LoaderComponent implements AfterViewInit {
  @Input() showLoader = false;
  displayLoader = false;
  options: AnimationOptions = {
    path: "../../../../assets/animations/nadel.loader.json",
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
      progressiveLoad: false,
      hideOnTransparent: true,
      className: "lottie-canvas",
    },
  };

  ngAfterViewInit(): void {
    this.displayLoader = true;
  }
}
